<template>
  <v-data-table
    :mobile-breakpoint='0'
    dense
    :headers='headers'
    :items='items'
    disable-sort
    hide-default-footer
    calculate-widths
    :items-per-page='-1'
  >
    <template v-slot:top><slot name='top'></slot></template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    reporte: Object,
    firstHeaders: {
      type: Array,
      default: () => [],
    },
    lastHeaders: {
      type: Array,
      default: () => [],
    },
    cRHeaders: {
      type: Array,
      default: () => [],
    },
    tRHeaders: {
      type: Array,
      default: () => [],
    },
    cCHeaders: {
      type: Array,
      default: () => [],
    },
    headerSort: {
      type: Function,
      default: (a, b) => 0,
    },
    headerKey: {
      type: String,
      default: 'value',
    },
    firstRows: {
      type: Array,
      default: () => [],
    },
    lastRows: {
      type: Array,
      default: () => [],
    },
    rowSort: {
      type: Function,
      default: (a, b) => 0,
    },
    rowKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headers: [],
      items: [],
      first: {
        headers: [],
        items: [],
      },
      last: {
        headers: [],
        items: [],
      },
      sort: {
        headers: (a, b) => 0,
        items: (a, b) => 0,
      },
      key: {
        headers: 'value',
        items: '',
      },
    };
  },
  methods: {
    setData() {
      if (Object.keys(this.reporte).length === 0) {
        this.headers = [];
        this.items = [];
        return;
      }
      this.first.headers = this.firstHeaders;
      this.first.items = this.firstRows;
      this.last.headers = this.lastHeaders;
      this.last.items = this.lastRows;
      this.sort.headers = this.headerSort;
      this.sort.items = this.rowSort;
      this.key.headers = this.headerKey;
      this.key.items = this.rowKey;
      this.setElements('headers');
      this.setElements('items');
    },
    setElements(propName) {
      this[propName] = [];
      this.addFoundElements(this.reporte[propName], this[propName], this.first[propName], this.key[propName]);
      this.addFoundElements(this.reporte[propName], this[propName], this.cRHeaders, this.key[propName]);
      this.addFoundElements(this.reporte[propName], this[propName], this.tRHeaders, this.key[propName]);
      this.addFoundElements(this.reporte[propName], this[propName], this.cCHeaders, this.key[propName]);
      const middleElements = [];
      for (const element of this.reporte[propName]) {
        const isInFirst = this.findElement(this.first[propName], element, this.key[propName]);
        const isInLast = this.findElement(this.last[propName], element, this.key[propName]);
        const isIncRHeaders = this.findElement(this.cRHeaders, element, this.key[propName]);
        const isIntRHeaders = this.findElement(this.tRHeaders, element, this.key[propName]);
        const isIncCHeaders = this.findElement(this.cCHeaders, element, this.key[propName]);
        if (!isInFirst && !isInLast && !isIncRHeaders && !isIntRHeaders && !isIncCHeaders) {
          middleElements.push(element);
        }
      }
      middleElements.sort(this.sort[propName]);
      for (const element of middleElements) {
        this[propName].push(element);
      }
      this.addFoundElements(this.reporte[propName], this[propName], this.last[propName], this.key[propName]);
    },
    findElement(arr, element, prop = '') {
      let found = null;
      if (prop === '') {
        found = (arr.findIndex((el) => el === element) > -1);
      } else {
        found = (arr.findIndex((el) => el === element[prop]) > -1);
      }
      return found;
    },
    addFoundElements(sourceArray, destinationArray, keyArray, propName = '') {
      for (const key of keyArray) {
        let found = null;
        if (propName === '') {
          found = sourceArray.find((element) => element === key);
        } else {
          found = sourceArray.find((element) => element[propName] === key);
        }
        if (found !== undefined && found !== null) {
          destinationArray.push(found);
        }
      }
    },
  },
  watch: {
    reporte() {
      console.log('watch reporte: MODIFICADO %o', this.reporte);
      this.setData();
    },
  },
};
</script>
